import { jsxs, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';

function Marquee({
  children,
  repeat = 2,
  className
}) {
  return jsxs("div", {
    className: "group flex flex-row overflow-hidden",
    children: [jsx("div", {
      className: "sr-only",
      children: children
    }), Array(repeat).fill(0).map((_, index) => jsx("div", {
      "aria-hidden": "true",
      className: clsx('flex shrink-0 animate-marquee flex-row justify-around ![animation-duration:40s] md:[@media(hover:hover)]:![animation-duration:80s] md:[@media(hover:hover)]:group-hover:![animation-play-state:paused]', className),
      children: children
    }, index))]
  });
}

export { Marquee };
